import { render, staticRenderFns } from "./CustomerTabsBooking.vue?vue&type=template&id=78551ed1&scoped=true&"
import script from "./CustomerTabsBooking.vue?vue&type=script&lang=js&"
export * from "./CustomerTabsBooking.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabsBooking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerTabsBooking.vue?vue&type=style&index=1&id=78551ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78551ed1",
  null
  
)

export default component.exports